module.exports = __webpack_public_path__ + "img/12.56095444.jpg";